import { useContext } from "react";
import { useMutation } from "react-query";
import { AxiosContext } from "services/axios.context";

export const useValidateApplePay = () => {
  const { client } = useContext(AxiosContext);

  return {
    validateApplePay: useMutation(
      (params) => {
        return client
          .post(`payment_methods/apple_pay/`, params)
          .then((resp) => resp.data);
      },
      {
        onSuccess: () => console.debug(`✅ Validated Apple Pay Merchant`),
        onError: (error) => console.error(error),
      }
    ),
  };
};
